import "./CategoryLayout.scss"
import { useSelector } from "react-redux";
const CategoryLayout = ({ data, setSelected, selected }) => {
    const company = useSelector((state) => state.companyData.company);
    return (
        <div className="CategoryLayoutV4" style={{ backgroundColor: company?.Style?.NavigationColor }}>

            <div className="CategoryLayoutV4-header">
                <div className="title-menu-catV4">
                    Menu Categories
                </div>
                <div className="count-menu-catV4">
                    {data?.length} Categories
                </div>
            </div>
            <div className="data-list-catV4">
                {data?.map((category, key) => {
                    return (
                        <div className={selected && category.ID === selected.ID ? "cat-layout-selected" : "cat-layout"} key={key}
                            onClick={() => {
                                setSelected(category)
                                const element = document.getElementById('CategoryPageV4');
                                element.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'start',
                                });
                            }}>
                            <img alt="" src={category?.Image} className={category?.Image?.includes(".svg") ? "cat-icon" : "cat-image"} />

                            <div className="cat-layout-btm">
                                {category?.Title?.en?.toLowerCase()}
                            </div>
                        </div>
                    )

                })}
            </div>
        </div>
    )

}
export default CategoryLayout